import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import {
  ConnectionChangeDto,
  ConnectionChangeRequestStatusEnum
} from '@bo-client/shared/models/connectionChange.dto';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectableStatus } from '@bo-client/shared/status/status.model';
import { StatusService } from '@bo-client/shared/status/status.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-ccr-change-status',
  templateUrl: './ccr-change-status.component.html',
  styleUrl: './ccr-change-status.component.scss'
})
export class CcrChangeStatusComponent
  implements
    CustomFormComponent<
      ConnectionChangeDto,
      {
        additionalData: string;
        comment: string;
      }
    >,
    OnInit
{
  private formBuilder = inject(FormBuilder);
  private statusService = inject(StatusService);

  @Input() data: DataForCustomFormModel<ConnectionChangeDto>;
  @Output() onConfirm: EventEmitter<{ additionalData: string; comment: string }> = new EventEmitter();

  model: ConnectionChangeDto;
  currentForm: ChangeStatusForm;
  statusOptions$: Observable<SelectableStatus[]>;

  ngOnInit() {
    this.model = this.data.model;
    this.statusOptions$ = this.statusService.selectableWithCurrent$(
      'connectionChangeRequest',
      this.model.state
    );
    this.currentForm = this.formBuilder.group({
      newState: [this.model.state as ConnectionChangeRequestStatusEnum, Validators.required],
      comment: [null as string, [Validators.required, Validators.maxLength(255)]]
    });
  }

  cancel = () => {
    this.onConfirm.emit(null);
  };

  confirm = (form: ChangeStatusForm) => {
    this.onConfirm.emit({
      additionalData: form.controls.newState.value,
      comment: form.controls.comment.value || ''
    });
  };
}

type ChangeStatusForm = FormGroup<{
  newState: FormControl<ConnectionChangeRequestStatusEnum>;
  comment: FormControl<string>;
}>;
